/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, type ReactNode } from 'react'

type OnboardingContextValue = {
  isOnboarding: boolean
  setIsOnboarding: (value: boolean) => void
}

const Ctx = createContext<OnboardingContextValue>({
  isOnboarding: false,
  setIsOnboarding: () => {},
})

export const useOnboarding = () => useContext(Ctx)

export function OnboardingProvider({ children }: { children: ReactNode }) {
  const [isOnboarding, setIsOnboarding] = useState(false)
  return <Ctx.Provider value={{ isOnboarding, setIsOnboarding }}>{children}</Ctx.Provider>
}
